(() => {
  if (window.__lpFormsInitialized) return;
  window.__lpFormsInitialized = true;

  const FORM_PARAM = 'lp_form';
  const STORAGE_KEY = 'lpSubmittedForm';
  let activeFormKey = '';

  function formKeyFromReturnTo(form) {
    const formKey = form.querySelector('input[name="lp_form_key"]');
    if (formKey && formKey.value) return formKey.value;

    const returnTo = form.querySelector('input[name="return_to"]');
    if (!returnTo || !returnTo.value) return '';

    try {
      return new URL(returnTo.value, window.location.origin).searchParams.get(FORM_PARAM) || '';
    } catch (_error) {
      return '';
    }
  }

  function getSubmittedFormKey() {
    const params = new URLSearchParams(window.location.search);
    const submittedFormKey = params.get(FORM_PARAM) || window.sessionStorage.getItem(STORAGE_KEY) || '';

    if (submittedFormKey) activeFormKey = submittedFormKey;
    return activeFormKey;
  }

  function clearSubmittedFormFromUrl() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has(FORM_PARAM)) return;

    url.searchParams.delete(FORM_PARAM);
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  }

  function rememberSubmittedForm(scope = document) {
    scope.querySelectorAll('form').forEach((form) => {
      if (form.dataset.lpSubmitTracked === 'true') return;

      const formKey = formKeyFromReturnTo(form);
      if (!formKey) return;

      form.addEventListener('submit', () => {
        window.sessionStorage.setItem(STORAGE_KEY, formKey);
      });
      form.dataset.lpSubmitTracked = 'true';
    });
  }

  function updateFeedback(scope = document) {
    const submittedFormKey = getSubmittedFormKey();

    scope.querySelectorAll('[data-lp-form-feedback]').forEach((feedback) => {
      const isActiveFeedback = feedback.dataset.lpFormFeedback === submittedFormKey;
      feedback.hidden = !isActiveFeedback;
      feedback.classList.toggle('is-visible', isActiveFeedback);
      feedback.setAttribute('aria-hidden', String(!isActiveFeedback));
    });

    if (submittedFormKey) {
      window.sessionStorage.removeItem(STORAGE_KEY);
      clearSubmittedFormFromUrl();
    }
  }

  function init(scope = document) {
    rememberSubmittedForm(scope);
    updateFeedback(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
